import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable, Subject } from 'rxjs';
import { SideNavItems, SidenavService } from 'src/app/services/sidenav.service';
import { NavItemComponent } from '../nav-item/nav-item.component';
import { NavListSeparatorComponent } from '../nav-list-separator/nav-list-separator.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [CommonModule, MatListModule, NavListSeparatorComponent, NavItemComponent, MatIconModule, MatTooltipModule],
})
export class SidebarComponent implements OnDestroy {
    @Input() isExpanded: boolean = false;
    @Output() isExpandedChange = new EventEmitter<boolean>();

    private readonly _ngUnsubscribe = new Subject<void>();

    sidenavItems: Observable<SideNavItems>;

    constructor(private _sidenavService: SidenavService) {
        this.sidenavItems = this._sidenavService.sidenavItemsObs;
    }

    ngOnDestroy() {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }

    toggleExpanded() {
        this.isExpanded = !this.isExpanded;
        this.isExpandedChange.emit(this.isExpanded);
    }
}
